import styles from './Profile.module.scss'
import BasicTitle from 'components/about/BasicTitle/BasicTitle'
import React, { useRef } from 'react'
import animationStyles from 'components/commons/Animation/Animation.module.scss'
import useElementVisible from 'components/commons/Animation/useElementVisible'

interface ProfileItem {
  leftText: string[]
  rightText: string
}

const profileItems: ProfileItem[] = [
  {
    leftText: ['代表取締役社長', 'CEO'],
    rightText: '芝 陽一郎',
  },
  {
    leftText: ['設立'],
    rightText: '2006年7月26日',
  },
  {
    leftText: ['営業開始'],
    rightText: '2011年8月1日',
  },
  {
    leftText: ['事業内容'],
    rightText: 'デジタルイノベーションパートナー事業',
  },
  {
    leftText: ['資本金および', '資本準備金'],
    rightText: '1億5,775万円',
  },
  {
    leftText: ['従業員数（BP含む）'],
    rightText: '135名',
  },
  {
    leftText: ['代表電話番号'],
    rightText: '03-6419-7700',
  },
  {
    leftText: ['FAX番号'],
    rightText: '03-6419-7703',
  },
  {
    leftText: ['所在地'],
    rightText: '〒107-0052<br>東京都港区赤坂八丁目１番22号<br>NMF青山一丁目ビル３階',
  },
  {
    leftText: ['アクセス'],
    rightText:
      '東京メトロ 銀座線/半蔵門線 都営大江戸線 青山一丁目駅 徒歩4分<br>東京メトロ 銀座線/丸ノ内線 赤坂見附駅 徒歩14分<br>東京メトロ 千代田線 乃木坂駅 徒歩12分',
  },
]

const bankItems: string[] = ['みずほ銀行　渋谷中央支店', '三井住友銀行　渋谷駅前支店']

const corporateItems: string[] = [
  '株式会社カネカ',
  'カヤバ株式会社',
  '株式会社Preferred Networks',
  'オムロン株式会社',
  'JFEエンジニアリング株式会社',
  '株式会社マネーフォワード',
  '損害保険ジャパン株式会社',
  '野村證券株式会社',
  '日本コープ共済生活協同組合連合会',
  '株式会社NTTドコモ',
  '東日本電信電話株式会社',
  '日本たばこ産業株式会社',
  '株式会社LIXIL',
  '他',
]

const certificationItems: string[] = [
  'AWSセレクトティアサービスパートナー',
  'Amazon ECS Delivery Partner',
  'GitLab Open Partner',
  'ISMS(ISO/IEC 27001:2022) 登録番号 GIJP-2169-IC',
  '特定非営利活動法人 人間中心設計推進機構',
  'AI駆動開発コンソーシアム',
]

const Profile: React.FC = () => {
  const textRef = useRef<HTMLDivElement | null>(null)
  const isVisible = useElementVisible(textRef, 0.1)

  const list = profileItems.map(({ leftText, rightText }) => {
    const formattedLeftText = Array.isArray(leftText) ? (
      leftText.map((text, index) => (
        <React.Fragment key={index}>
          {text}
          {index < leftText.length - 1 && <br />}
        </React.Fragment>
      ))
    ) : (
      <React.Fragment>{leftText}</React.Fragment>
    )
    if (leftText[0] === '所在地') {
      return (
        <li key={leftText[0]} className={styles.line}>
          <div className={styles.line_wrapper}>
            <div className={styles.line_wrapper_flex}>
              <span className={styles.left_title}>{leftText[0]}</span>
              <p
                className={`${styles.left_text} ${styles.left_text_location}`}
                dangerouslySetInnerHTML={{ __html: rightText }}
              ></p>
            </div>
            <iframe
              className={styles.map}
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3241.669900363869!2d139.7251261!3d35.673452!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188ca66b638993%3A0x422d4622e50c7d!2sAitria%20Co.%2C%20Ltd.!5e0!3m2!1sja!2sjp!4v1680251008776!5m2!1sja!2sjp"
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </li>
      )
    } else {
      return (
        <li key={leftText.join()} className={styles.line}>
          <span className={styles.left_title}>{formattedLeftText}</span>
          <p className={styles.left_text} dangerouslySetInnerHTML={{ __html: rightText }}></p>
        </li>
      )
    }
  })

  const bankList = bankItems.map(
    (text): JSX.Element => (
      <li key={text} className={styles.right_text}>
        {text}
      </li>
    ),
  )
  const corporateList = corporateItems.map(
    (text): JSX.Element => (
      <li key={text} className={styles.right_text}>
        {text}
      </li>
    ),
  )
  const certificationList = certificationItems.map(
    (text): JSX.Element => (
      <li key={text} className={styles.right_text}>
        {text}
      </li>
    ),
  )

  const sectionTitle = {
    title: 'Corporate profile',
    sub_title: '企業情報',
  }

  return (
    <section className={`${styles.contents} profile_wrapper`} id="profile_top">
      <div className={styles.border}></div>
      <div className={styles.title_group}>
        <BasicTitle sectionTitle={sectionTitle} />
      </div>
      <div
        className={`${styles.content} ${animationStyles.fade} ${isVisible ? animationStyles.fadeOn : ''}`}
        ref={textRef}
      >
        <ul className={styles.left_profile_group}>
          <li className={`${styles.line} ${styles.line_first}`}>
            <span className={styles.left_title}>社名</span>
            <p className={styles.left_text}>
              Aitria株式会社（旧：株式会社アイスリーデザイン）
              <br />
              英字表記：Aitria Co., Ltd.
            </p>
          </li>
          <div>{list}</div>
        </ul>
        <ul className={styles.right_profile_group}>
          <li className={`${styles.line} ${styles.line_right}`}>
            <span className={styles.right_title}>取引先金融機関</span>
            <ul className={styles.right_profile_group}>{bankList}</ul>
          </li>
          <li className={`${styles.line} ${styles.line_right}`}>
            <span className={styles.right_title}>取引先企業</span>
            <ul className={`${styles.right_profile_group} ${styles.corporate}`}>{corporateList}</ul>
          </li>
          <li className={`${styles.line} ${styles.rights_last}`}>
            <span className={styles.right_title}>取得認証</span>
            <ul className={styles.right_profile_group}>{certificationList}</ul>
          </li>
        </ul>
      </div>
    </section>
  )
}

export default Profile
